module.exports = __webpack_public_path__ + "static/media/flash.d21f4411.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/flash.png
// module id = 607
// module chunks = 0